// src/App.js
import React, { Component } from "react";

import { Navbar, Nav, NavItem, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import tabsLogo from "./img/TABS_Analytics_logo.png";
import "./App.css";
import TabsApps from "./components/tabsApps";
import Profile from "./components/profile";
import PPTCart from "./components/pptCart";
import Notifications from "./components/notifications";
import { Help, ChatIcon, CloseIcon } from "./lib/icons";
import { setIdpInitiatedLogin } from "./reducers/authReducer";
import { getApps } from "./reducers/appReducer";
import Login from "./components/login";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import { setupAxiosInterceptors } from "./lib/axiosConfig";
import withRouter from "./hocs/withRouter";
import { preloadPowerBI } from "./lib/pbiPreload";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gotReports: false,
      loadedApps: false,
      listOpen: false,
      zohoScriptInjected: false,
      chatWidgetOpen: false,
    };

    // Safe check for location
    if (this.props.location?.hash?.indexOf("access_token") !== -1 || this.props.idpLogin) {
      this.props.setIdpInitiatedLogin(true);
    }
  }

  componentDidMount() {
    if (this.props.location.pathname.includes("/setClient") && window.location.hash) {
      const authDone = this.props.auth.handleSetClient();
      if (authDone && typeof authDone.then === "function") {
        // msal mode: the preview token is exchanged for a cookie session first
        authDone.then(() => this.continueAfterAuth());
      } else {
        setTimeout(() => {
          this.continueAfterAuth();
        }, 200);
      }
      return;
    }

    setupAxiosInterceptors(this.props.auth);

    if (this.props.auth.isAuthenticated()) {
      this.props.auth.resumeActivityTracking();
      preloadPowerBI();
      const sso = localStorage.getItem("sso");
      if (sso === "false" || sso === null || sso === false) {
        if (this.props.location.pathname.includes("/uploadFile")) {
          this.props.getApps(false, true);
        } else if (this.props.location.pathname.includes("/tabsFileShare")) {
          this.props.getApps(false, false, true);
        } else {
          this.props.getApps();
        }
      } else {
        if (this.props.location.pathname.includes("/uploadFile")) {
          this.props.getApps(false, true);
        } else if (this.props.location.pathname.includes("/tabsFileShare")) {
          this.props.getApps(false, false, true);
        } else {
          this.props.getApps(true);
        }
      }

      this.setState({ loadedApps: true });
    }

    if (
      window.location.pathname !== undefined &&
      window.location.pathname !== "/" &&
      window.location.pathname !== "/index.html" &&
      !window.location.pathname.includes("callback") &&
      !window.location.pathname.includes("setClient") &&
      !window.location.pathname.includes("uploadFile") &&
      !window.location.pathname.includes("tabsFileShare")
    ) {
      if (window.location.href.includes("/files/landing?download=")) {
        const file = window.location.href.split("/files/landing?download=")[1];
        localStorage.setItem("continueUrl", "/files/landing?download=" + file);
      } else {
        // Preserve query string (e.g. ?appId=) so params survive the auth redirect cycle.
        localStorage.setItem("continueUrl", window.location.pathname + window.location.search);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { defaultApp, homePage } = this.props;
    var urlChanged = false;
    var defaultFound;

    if (this.props.auth.isAuthenticated()) {
      const { loadedApps } = this.state;
      preloadPowerBI();
      let continueUrl = localStorage.getItem("continueUrl");

      // Clean up invalid continueUrl
      if (continueUrl === "/index.html" || continueUrl === "index.html") {
        continueUrl = null;
        localStorage.removeItem("continueUrl");
      }

      if (prevProps.showSupportChat !== this.props.showSupportChat) {
        if (this.props.showSupportChat && !this.state.zohoScriptInjected) {
          this.injectZohoScript();
          this.setState({ zohoScriptInjected: true });
        } else if (!this.props.showSupportChat && this.state.zohoScriptInjected) {
          this.removeZohoScript();
          this.setState({ zohoScriptInjected: false });
        }
      } else if (this.props.showSupportChat && !this.state.zohoScriptInjected) {
        this.injectZohoScript();
        this.setState({ zohoScriptInjected: true });
      }

      if (this.props.apps.length === 0 && !loadedApps) {
        const sso = localStorage.getItem("sso");

        if (sso === "false" || sso === null || sso === false) {
          this.props.getApps();
        } else {
          this.props.getApps(true);
        }
        this.setState({ loadedApps: true });
      } else if (continueUrl !== null && continueUrl !== undefined && continueUrl !== "" && continueUrl !== "/") {
        this.props.history.replace(continueUrl);
        localStorage.removeItem("continueUrl");
      } else if (defaultApp !== null) {
        if (
          this.props.location.pathname === "/" ||
          this.props.location.pathname === "/index.html" ||
          this.props.location.pathname.includes("callback") ||
          this.props.location.pathname === "/setClient"
        ) {
          if (homePage !== null && homePage !== undefined && Object.entries(homePage).length > 0) {
            if (homePage.link.includes("/landing") || homePage.link.includes("/report/")) {
              this.props.history.push(homePage.link);
            } else {
              defaultFound = this.props.apps.filter((item) => {
                return homePage.link.includes(item.link);
              });
              if (defaultFound.length > 0) {
                this.props.history.replace(homePage.link);
              } else if (this.props.apps.length > 0 && this.props.workspaces.length > 0) {
                if (this.props.apps[0].type === "powerBI" || this.props.apps[0].type === "tableau") {
                  this.props.history.replace("/reports");
                } else {
                  this.props.history.replace(this.props.apps[0].link);
                }
              }
            }
          } else if (defaultApp.link !== undefined) {
            if (defaultApp.link === "fileUpload") {
              urlChanged = true;
            } else if (defaultApp.link === "fileShare") {
              urlChanged = true;
            } else if (defaultApp.link.includes("/landing") && this.props.workspaces.length > 0) {
              defaultFound = this.props.workspaces.filter((item) => {
                return defaultApp.name.toLowerCase() === item.name.toLowerCase();
              });
            } else {
              defaultFound = this.props.apps.filter((item) => {
                if (item.link === undefined && defaultApp.name !== undefined) {
                  return defaultApp.name.toLowerCase() === item.type.toLowerCase();
                } else {
                  if (
                    item.type === "reporting" &&
                    (defaultApp.link.includes("/landing") || defaultApp.link.includes("/report/"))
                  ) {
                    return true;
                  } else {
                    return defaultApp.link.includes(item.link);
                  }
                }
              });
            }

            if (!urlChanged && defaultFound.length > 0) {
              this.props.history.replace(defaultApp.link);
            } else if (this.props.apps.length > 0 && this.props.workspaces.length > 0) {
              if (this.props.apps[0].type === "powerBI" || this.props.apps[0].type === "tableau") {
                this.props.history.replace("/reports");
              } else {
                this.props.history.replace(this.props.apps[0].link);
              }
            }
          } else {
            let rptsFound = this.props.apps.filter((item) => {
              if (item.link === undefined) {
                return false;
              }
              return item.link.includes("/reports");
            });
            if (rptsFound.length > 0) {
              this.props.history.replace("/reports");
            } else if (this.props.apps.length > 0) {
              if (this.props.apps[0].type === "powerBI" || this.props.apps[0].type === "tableau") {
                this.props.history.replace("/reports");
              } else {
                this.props.history.replace(this.props.apps[0].link);
              }
            } else {
              this.props.history.replace("/noPermissions");
            }
          }
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.props.auth && this.props.auth.cleanup) {
      this.props.auth.cleanup();
    }
  }

  continueAfterAuth() {
    setupAxiosInterceptors(this.props.auth);

    if (this.props.auth.isAuthenticated()) {
      if (localStorage.getItem("sso") === "false" || localStorage.getItem("sso") === undefined) {
        this.props.getApps();
      } else {
        this.props.getApps(true);
      }
      this.setState({ loadedApps: true });
    }
  }

  goTo(route) {
    this.props.history.replace(`/${route}`);
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  removeZohoScript = () => {
    const existingScript = document.querySelector("script[src*='zoho.com']");
    if (existingScript) {
      existingScript.remove();
    }

    const zohoWidget = document.querySelector("#zsalesiq");
    if (zohoWidget) {
      zohoWidget.remove();
    }

    if (window.ZOHOIM) {
      delete window.ZOHOIM;
    }
  };

  injectZohoScript = () => {
    const userString = localStorage.getItem("user") || "Unknown User";

    window.ZOHOIM = window.ZOHOIM || {};
    window.ZOHOIM.widgetProps = {
      contactInfo: {
        name: userString,
        email: userString,
      },
    };

    window.ZOHOIM.widgetLayout = {
      showWidget: false, // Start with widget hidden
      needWidgetBubble: false, // Hide the default Zoho chat button
      needCloseIcon: true,
    };

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.defer = true;
    script.src = "https://im.zoho.com/api/v1/public/channel/1a4b8008916d56c98a05b944c320c6ef/widget";
    script.onload = () => {
      // Listen for Zoho widget close events
      this.setupZohoListeners();
    };
    document.head.appendChild(script);
  };

  setupZohoListeners = () => {
    // Poll to check if window.ZOHOIM is ready
    const checkInterval = setInterval(() => {
      if (window.ZOHOIM && window.ZOHOIM.subscribeToEvent) {
        clearInterval(checkInterval);

        // Subscribe to widget close/hide events
        window.ZOHOIM.subscribeToEvent("widgetHidden", () => {
          this.setState({ chatWidgetOpen: false });
        });

        window.ZOHOIM.subscribeToEvent("widgetClosed", () => {
          this.setState({ chatWidgetOpen: false });
        });
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  };

  renderLogin() {
    const { isAuthenticated } = this.props.auth;
    // if (
    //   this.props.location.hash.indexOf("access_token") !== -1 ||
    //   this.props.idpLogin
    // ) {
    //   //commented this out and put this in the constructor.
    //   //Cannot change state in render.
    //   //this.props.setIdpInitiatedLogin(true);
    //   return <div />;
    const loggingIn = sessionStorage.getItem("logging_in") === "true";
    const isSetClient = this.props.location.pathname.includes("/setClient");
    if (loggingIn || isSetClient) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "300px",
          }}>
          <div>Authenticating...</div>
        </div>
      );
    }
    if (!isAuthenticated()) {
      return (
        <div>
          <div className="login-heading">Welcome to TABS Insight Portal!</div>
          <div className="login-wrapper">
            <div className="login-msg">
              You are not logged in. Please log in to continue.
              <div className="login-help">
                <OverlayTrigger
                  placement={"top"}
                  rootClose={true}
                  overlay={
                    <Tooltip id={"login-help"}>
                      Log in using your email address and your Microsoft O365 password. Typically these credentials are the same
                      as your corporate email or computer login.
                    </Tooltip>
                  }
                  trigger={["hover", "focus"]}>
                  <div>
                    <Help className="help" height={"20px"} width={"20px"} color={"rgba(88, 89, 91, 1)"} />
                  </div>
                </OverlayTrigger>
              </div>
            </div>
            <Login auth={this.props.auth} />
          </div>
          <div className="login-info">
            <p>Need Help?</p>
            <p>
              TABS Analytics Support
              <br />
              support@tabsanalytics.com
              <br />
              (203) 925-9162
            </p>
          </div>
        </div>
      );
    }
  }

  toggleList() {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  }

  toggleChatWidget = () => {
    if (!this.state.chatWidgetOpen) {
      // Opening the widget
      this.openZohoWidget();
      this.setState({ chatWidgetOpen: true });
    } else {
      // Closing the widget
      this.closeZohoWidget();
      this.setState({ chatWidgetOpen: false });
    }
  };

  openZohoWidget = () => {
    if (window.ZOHOIM) {
      try {
        const { triggerEvent } = window.ZOHOIM;
        triggerEvent("openWidget");
      } catch (error) {}
    } else {
    }
  };

  closeZohoWidget = () => {
    if (window.ZOHOIM) {
      try {
        const { triggerEvent } = window.ZOHOIM;
        triggerEvent("closeWidget");
      } catch (error) {}
    } else {
    }
  };

  render() {
    return (
      <>
        <div
          className="ta-header"
          style={{
            position: "fixed",
            background: "white",
            top: "0",
            width: "100%",
            zIndex: 100,
          }}>
          <Navbar className="ta-navbar">
            <Navbar.Brand style={{ display: "flex", flexDirectin: "column" }} className="ta-apps-brand">
              {this.props.auth.isAuthenticated() &&
                !(
                  this.props.location.pathname.includes("/uploadFile") ||
                  this.props.location.pathname.includes("/tabsFileShare")
                ) && <TabsApps className="ta-apps" auth={this.props.auth} isAuthenticated={this.props.auth.isAuthenticated} />}
              <div style={{ height: "45px" }}>
                <img src={tabsLogo} alt="Tabs Analytics" className="ta-logo" />
              </div>
            </Navbar.Brand>
            {this.props.auth.isAuthenticated() &&
              !(
                this.props.location.pathname.includes("/uploadFile") || this.props.location.pathname.includes("/tabsFileShare")
              ) && (
              <Nav
                style={{
                  flexDirection: "row",
                  height: "45px",
                  marginBottom: "5px",
                  alignItems: "center",
                  marginLeft: "auto",
                }}>
                {this.props.logo !== "" ? (
                  <NavItem style={{ paddingRight: "20px" }}>
                    <img src={this.props.logo} height="20px" alt="logo" />
                  </NavItem>
                ) : null}
                {this.props.inboxId === "" && (
                  <>
                    {this.props.showSupportChat && (
                      <OverlayTrigger
                        placement={"left"}
                        overlay={
                          <Tooltip id={"support-chat-tooltip"} style={{ zIndex: 2147483647 }}>
                            {this.state.chatWidgetOpen ? "Close support chat" : "Open support chat"}
                          </Tooltip>
                        }
                        trigger={["hover", "focus"]}>
                        <NavItem
                          onClick={this.toggleChatWidget}
                          style={{
                            // marginRight: "10px",
                            cursor: "pointer",
                            display: "flex",
                            transition: "transform 0.3s ease",
                          }}>
                          {this.state.chatWidgetOpen ? (
                            <CloseIcon
                              className="chat-toggle"
                              height={"16px"}
                              width={"16px"}
                              viewBox="0 0 20 20"
                              color={"rgba(88, 89, 91, 1)"}
                              style={{
                                animation: "rotateIn 0.3s ease",
                              }}
                            />
                          ) : (
                            <ChatIcon
                              className="chat-toggle"
                              height={"20px"}
                              width={"20px"}
                              color={"rgba(88, 89, 91, 1)"}
                              style={{
                                animation: "rotateIn 0.3s ease",
                              }}
                            />
                          )}
                        </NavItem>
                      </OverlayTrigger>
                    )}
                    <Notifications />
                    <OverlayTrigger placement={"left"} overlay={<Tooltip id={"help-tooltip"}>Open Support Website</Tooltip>}>
                      <NavItem
                        onClick={() => {
                          var element = window.document.createElement("a");
                          element.setAttribute("href", "https://support.tabsanalytics.com/portal/");
                          element.setAttribute("target", "_blank");
                          element.style.display = "none";
                          document.body.appendChild(element);
                          element.click();
                          document.body.removeChild(element);
                        }}
                        style={{
                          marginRight: "10px",
                          cursor: "pointer",
                          display: "flex",
                        }}>
                        <Help className="help" height={"20px"} width={"20px"} color={"rgba(88, 89, 91, 1)"} />
                      </NavItem>
                    </OverlayTrigger>
                    <PPTCart />
                    <OverlayTrigger placement={"left"} overlay={<Tooltip id={"profile-tooltip"}>Profile</Tooltip>}>
                      <NavItem href="#">
                        <Profile className="ta-profile" auth={this.props.auth} />
                      </NavItem>
                    </OverlayTrigger>
                  </>
                )}
              </Nav>
            )}
          </Navbar>
          {this.renderLogin()}
        </div>
        <ToastContainer
          enableMultiContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          style={{ zIndex: 100000 }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  workspaces: state.reportList.workspaces,
  apps: state.app.apps,
  logo: state.app.logo,
  searchApps: state.app.searchApps,
  idpLogin: state.auth.idpLogin,
  isAuthed: state.auth.isAuthed,
  appError: state.app.error,
  loading: state.reportList.loading,
  error: state.reportList.error,
  defaultApp: state.app.defaultApp,
  homePage: state.app.homePage,
  inboxId: state.app.inboxId,
  showSupportChat: state.app.showSupportChat,
});

const mapDispatchToProps = (dispatch) => ({
  setIdpInitiatedLogin(value) {
    dispatch(setIdpInitiatedLogin(value));
  },
  getApps(sso, uploadOnly, fileShare) {
    dispatch(getApps(sso, uploadOnly, fileShare));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
